import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { get, isEmpty, find } from 'lodash';
import { fetchReferralBalance } from '../actions/profile';
import { fetchGuestReferralEntitlements } from '../actions/entitlements';
import ReferralsMain from '../../app-referrals/referrals-main';
import { PageSpinner } from 'shared-components/decorators/spinner';

class ReferralContainer extends Component {
  constructor (props) {
    super(props);
  }

  componentDidUpdate (prevProps) {
    const { dispatch, SSOid, accessToken } = this.props;
    const prevSSOid = get(prevProps, 'profile.SSOid', '');

    // if user logs out, redirect to sign in
    if (!accessToken) {
      window.location.href = '/signin';
    }

    if (!prevSSOid && SSOid) {
      dispatch(fetchReferralBalance(SSOid, accessToken));
      dispatch(fetchGuestReferralEntitlements(SSOid, accessToken));
    }
  }

  render () {
    const { referralBalance, guestReferralEntitlement, entitlementError, SSOid } = this.props;
    const referralCount = get(referralBalance, 'count', 0);
    const referralBalanceAmount = get(referralBalance, 'total_amount_issued', 0);
    const referralBalanceError = get(referralBalance, 'error', '');
    const entitlementId = get(guestReferralEntitlement, 'external_id', '');
    const entitlementDescription = get(guestReferralEntitlement, 'description', 'Give $50. Get $50.');
    const referralDiscountDetails = find(get(guestReferralEntitlement, 'actions', []), { type: 'GUEST_REFERRAL_DISCOUNT' }) || {};
    const discountValue = get(referralDiscountDetails, 'value', 50);
    const minimumBookingSubtotal = get(referralDiscountDetails, 'minimum_booking_subtotal', 150);
    const referrerCreditDetails = find(get(guestReferralEntitlement, 'actions', []), { type: 'REFERRER_ISSUE_CREDITS' }) || {};
    const creditValue = get(referrerCreditDetails, 'value', 50);

    return (
      ((isEmpty(guestReferralEntitlement) && !entitlementError) || isEmpty(referralBalance)) ? <PageSpinner additionalStyle="gray" /> :
        <ReferralsMain
          referralCount={referralCount}
          referralBalanceAmount={referralBalanceAmount}
          referralBalanceError={referralBalanceError}
          entitlementId={entitlementId}
          entitlementError={entitlementError}
          entitlementDescription={entitlementDescription}
          creditValue={creditValue}
          discountValue={discountValue}
          minimumBookingSubtotal={minimumBookingSubtotal}
          SSOid={SSOid}
        />
    );
  }
}

ReferralContainer.propTypes = {
  dispatch: PropTypes.func,
  SSOid: PropTypes.string,
  accessToken: PropTypes.string,
  referralBalance: PropTypes.object,
  guestReferralEntitlement: PropTypes.object,
  entitlementError: PropTypes.string
};

function mapStateToProps (state) {
  const { auth, nav, profile, nux, entitlements } = state;
  const { accessToken } = auth;
  const { SSOid, referralBalance } = profile;
  const guestReferralEntitlement = get(entitlements, 'guestReferralData.entitlements.0', {});
  const entitlementError = get(entitlements, 'guestReferralError', '');

  return {
    auth,
    nav,
    profile,
    SSOid,
    accessToken,
    nux,
    referralBalance,
    guestReferralEntitlement,
    entitlementError
  };
}

export default connect(mapStateToProps)(ReferralContainer);
